export enum ScheduleEntryType {
  ONCE = "ONCE",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export interface ScheduleEntriesFormValues {
  schedule_entries: ScheduleEntryInput[];
}

// TODO: AM: Extract to common types
export interface ScheduleEntryInput {
  type: ScheduleEntryType;
  weekdays: number[];
  from_time: string;
  to_time: string;
  once_start_date: string;
  once_end_date: string;
  monthday?: number;
  monthday_from?: number;
  monthday_to?: number;
}

export enum ScheduleWeekday {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY,
}

export const WeekNames: Record<ScheduleWeekday, string> = {
  [ScheduleWeekday.MONDAY]: "Monday",
  [ScheduleWeekday.TUESDAY]: "Tuesday",
  [ScheduleWeekday.WEDNESDAY]: "Wednesday",
  [ScheduleWeekday.THURSDAY]: "Thursday",
  [ScheduleWeekday.FRIDAY]: "Friday",
  [ScheduleWeekday.SATURDAY]: "Saturday",
  [ScheduleWeekday.SUNDAY]: "Sunday",
};

export const WEEKDAYS = [
  ScheduleWeekday.MONDAY,
  ScheduleWeekday.TUESDAY,
  ScheduleWeekday.WEDNESDAY,
  ScheduleWeekday.THURSDAY,
  ScheduleWeekday.FRIDAY,
  ScheduleWeekday.SATURDAY,
  ScheduleWeekday.SUNDAY,
];

export const sortWeekdays = (a: number, b: number) => {
  if (a === 0) {
    return 1;
  }

  return a - b;
};
